export const parsePromptLibrary = (data) => {
  if (!data || !Array.isArray(data.prompts) || typeof data.default_prompt !== 'string') {
    throw new Error('Invalid saved prompt response');
  }
  const ids = new Set();
  for (const prompt of data.prompts) {
    if (!prompt || typeof prompt.prompt_id !== 'string' || !prompt.prompt_id || ids.has(prompt.prompt_id) ||
        typeof prompt.name !== 'string' || typeof prompt.prompt !== 'string' ||
        !Number.isInteger(prompt.revision) || prompt.revision < 1) {
      throw new Error('Invalid saved prompt entry');
    }
    ids.add(prompt.prompt_id);
  }
  return { default_prompt: data.default_prompt, prompts: data.prompts };
};